<template>
  <div class="personalSwitch">
    <!-- <group > -->
    <x-switch
      style="background:#fff"
      title="开启任务通知提醒"
      :value-map="[0, 1]"
      v-model="openStatus"
    ></x-switch>
    <!-- <cell title="value" :value="typeof stringValue + ' ' + stringValue"></cell> -->
    <!-- </group> -->
    <div v-show="openStatus">
      <div class="label-check">
        星期
      </div>
      <div class="box">
        <checker
          v-model="checkValue"
          type="checkbox"
          default-item-class="demo1-item"
          selected-item-class="demo1-item-selected"
        >
          <checker-item
            class="check-self-item"
            :value="item"
            v-for="(item, index) in checkItemList"
            :key="index"
          >
            {{ item.value }}
          </checker-item>
        </checker>
      </div>
    </div>

    <div class="" style="width: 100%;background: #f7f7f7;">
      <x-button class="send" @click.native="send">保存</x-button>
    </div>
  </div>
</template>

<script>
// TODO: vux
import {
  XSwitch,
  Group,
  Cell,
  Checker,
  CheckerItem,
  Divider,
  XButton
} from 'vux';
import { personal } from '@/api/ajax.js';
export default {
  name: '',
  data() {
    return {
      openStatus: 1,
      userInfo: {},
      checkValue: [],
      checkItemList: [
        {
          key: 'monStatus',
          value: '一'
        },
        {
          key: 'tuesStatus',
          value: '二'
        },
        {
          key: 'wedStatus',
          value: '三'
        },
        {
          key: 'thurStatus',
          value: '四'
        },
        {
          key: 'friStatus',
          value: '五'
        },
        {
          key: 'satStatus',
          value: '六'
        },
        {
          key: 'sunStatus',
          value: '日'
        }
      ]
    };
  },
  methods: {
    onClickSwitch(newVal, oldVal) {
      this.openStatus = newVal;
    },
    send() {
      let that = this;
      let dates = {};
      let openStatus = this.openStatus;
      let stringItemValue = JSON.stringify(this.checkValue);
      this.checkItemList.filter(item => {
        // this.checkValue.filter(item2 => {
        //   dates[item.key] =
        // })
        dates[item.key] = stringItemValue.includes(item.key) ? 1 : 0;
      });

      personal
        .remindOpen({
          wxOpenId: this.userInfo.wxOpenId,
          openStatus,
          ...dates
        })
        .then(res => {
          if (res.data.status == 1) {
            this.$vux.toast.show({
              text: '修改成功',
              type: 'success',
              width: '5rem',
              onHide() {
                that.$router.go(-1);
              }
            });
          } else {
            this.$vux.toast.show({
              text: '修改失败，请重试',
              type: 'cancel',
              width: '5rem'
            });
          }
        });
    }
  },

  computed: {},
  components: {
    XSwitch,
    Group,
    Cell,
    Checker,
    CheckerItem,
    Divider,
    XButton
  },
  created() {
    this.userInfo = this.$api.getStorage('wxUserInfo') || {};
    let stringCheckItemList = JSON.stringify(this.checkItemList);
    personal
      .pushInfo({
        wxOpenId: this.userInfo.wxOpenId
      })
      .then(res => {
        let resp = res.data.data;
        this.openStatus = resp.openStatus;
        Object.keys(resp).filter((item, index) => {
          this.checkItemList.filter((item2, index2) => {
            if (resp[item] == 1 && item == item2.key) {
              this.checkValue.push(item2);
            }
          });
        });
      });
  }
};
</script>
<style lang="less" scoped>
.box {
  background: #fff;
  padding: 0.16rem 0.4rem;
}

.check-self-item {
  width: 0.8133rem /* 61/75 */;
  height: 0.8133rem /* 61/75 */;
  border-radius: 50%;
  font-size: 0.4533rem /* 34/75 */;
  border: 1px solid #027cfa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.3067rem /* 23/75 */;
}

.demo1-item {
  color: #027cfa;
  background: #fff;
}

.demo1-item-selected {
  color: #fff;
  background: #027cfa;
}

.send {
  width: 7.7333rem /* 580/75 */;
  height: 1.1733rem /* 88/75 */;
  background: #027cfa;
  border-radius: 0.1067rem /* 8/75 */;
  color: #fff;
  font-size: 0.4533rem /* 34/75 */;
  margin-top: 1.6rem /* 120/75 */;
}

.label-check {
  width: 100%;
  height: 1.6rem /* 140/75 */;
  background: #f7f7f7;
  font-size: 0.3733rem /* 28/75 */;
  color: #909090;
  padding-top: 0.8rem;
  padding-left: 0.4rem;
}
</style>
<style lang="less">
.personalSwitch {
  // position: fixed;
  width: 100%;
  height: 15.5rem;
  background: #f7f7f7;
  .weui-switch:checked,
  .weui-switch-cp__input:checked ~ .weui-switch-cp__box {
    border-color: #027cfa;
    background-color: #027cfa;
  }
  .weui-label {
    font-size: 0.3733rem;
    font-weight: bold;
  }
  .vux-checker-box {
    display: flex;
    justify-content: center;
  }
}
</style>
